let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1K1Fj"), load("xnqy2"), load("8hOn0"), load("cM3gY"), load("7PjNK"), load("Vt6S9")]).then(() => parcelRequire('b2Gxi'));